import { Card, Modal, Row } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import ReactAudioPlayer from "react-audio-player";
import { useEffect, useRef, useState } from "react";
import { decryptData } from "../../utils";

export function PlayAudioMpdal({
  callId,
  caseId,
  isVisible,
  recordingUrl,
  handleModalVisibility,
}: {
  caseId: string;
  callId: string;
  isVisible?: boolean;
  recordingUrl: string;
  handleModalVisibility: () => void;
}) {
  const [audioSrc, setAudioSrc] = useState<string>("");
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    if (!isVisible || !recordingUrl) return;

    let objectUrl: string | null = null;
    let cancelled = false;

    const fetchAudio = async () => {
      try {
        const res = await fetch(decryptData(recordingUrl));
        console.log("FETCH STATUS:", res.status);
        console.log("CONTENT-TYPE:", res.headers.get("content-type"));

        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const blob = await res.blob();
        objectUrl = URL.createObjectURL(blob);

        if (!cancelled) {
          setAudioSrc(objectUrl);
        }
      } catch (err) {
        console.error("Audio fetch failed:", err);
        setAudioSrc("");
      }
    };

    fetchAudio();

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
      setAudioSrc("");
    };
  }, [recordingUrl, isVisible]);

  const handleClose = () => {
    handleModalVisibility();
    const audioElement = document.querySelector("audio");
    if (audioElement) {
      audioElement.pause();
      audioElement.currentTime = 0;
    }
  };

  return (
    <Modal open={isVisible} footer={null} closable={false}>
      <Card
        title="Play Recording"
        extra={
          <CloseOutlined
            className="text-lg cursor-pointer"
            onClick={handleClose}
          />
        }
      >
        <Row className="flex justify-center">
          <ReactAudioPlayer
            key={Math.random()}
            src={recordingUrl}
            controls
            controlsList={"nodownload"}
            autoPlay
            onPlay={(e) => console.log(e)}
            onAbort={(e) => console.log("onAbourt", e)}
          />
        </Row>
      </Card>
    </Modal>
  );
}
